import { OpenReportAction, OpenReportTypes } from '../../types';
import { Reducer } from 'redux';

export const loginState = {
  username: '',
  password: '',
};

export interface LoginState {
  username: string;
  password: string;
}

const loginReducer: Reducer<LoginState, OpenReportAction> = (
  state: LoginState = loginState,
  action: OpenReportAction,
): LoginState => {
  switch (action.type) {
    case OpenReportTypes.RESET:
      return loginState;
    case OpenReportTypes.SET_PASSWORD:
      const password = action.payload.currentTarget.value;
      return {
        ...state,
        password,
      };
    case OpenReportTypes.SET_LOGIN_USERNAME:
      const loginUsername = action.payload.currentTarget.value;
      return {
        ...state,
        username: loginUsername,
      };
    case OpenReportTypes.SET_LOGIN_PASSWORD:
      const loginPassword = action.payload.currentTarget.value;
      return {
        ...state,
        password: loginPassword,
      };
    case OpenReportTypes.ON_SUBMIT:
      const { username } = action.payload.loginValues;
      return {
        ...state,
        username,
      };
    default:
      return state;
  }
};

export default loginReducer;
